import { render, staticRenderFns } from "./RegistrationSentPage.vue?vue&type=template&id=14811499&scoped=true&"
import script from "./RegistrationSentPage.vue?vue&type=script&lang=ts&"
export * from "./RegistrationSentPage.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationSentPage.vue?vue&type=style&index=0&id=14811499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14811499",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
